import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { MdExpandMore } from 'react-icons/md';

import TopPresentation from '../../../components/TopPresentation';
import quemSomosImgMobile from '../../../img/topo-quem-somos-mobile.png';
import quemSomosImg from '../../../img/topo-quem-somos.png';

const useStyles = makeStyles(theme => ({
  container: {
    '& .social': {
      '& svg': {
        color: theme.palette.primary.main,
        transition: 'filter 0.4s',
        '&:hover': {
          filter: 'brightness(60%)',
        },
      },
    },
  },
}));

export default function TopWhoWeAre() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <TopPresentation
        images={[quemSomosImg, quemSomosImgMobile]}
        title={t(
          'Saiba mais sobre a Rede de Depilação a laser que mais cresce no Brasil',
        )}
        subTitle={t('Quem somos')}
        invertTitle="true"
        iconButton={<MdExpandMore size={25} />}
      />
    </Grid>
  );
}
